import { render, staticRenderFns } from "./EditBrigade.vue?vue&type=template&id=fc8b27d4&scoped=true&"
import script from "./EditBrigade.vue?vue&type=script&lang=js&"
export * from "./EditBrigade.vue?vue&type=script&lang=js&"
import style0 from "./EditBrigade.vue?vue&type=style&index=0&id=fc8b27d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc8b27d4",
  null
  
)

export default component.exports
import {QCard,QCardSection,QToolbar,QToolbarTitle,QTabs,QTab,QTooltip,QBadge,QIcon,QItem,QInput,QSelect,QItemSection,QList,QItemLabel,QBanner,QInnerLoading,QSpinnerGears,QSeparator,QCardActions,QBtn,ClosePopup} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QToolbar,QToolbarTitle,QTabs,QTab,QTooltip,QBadge,QIcon,QItem,QInput,QSelect,QItemSection,QList,QItemLabel,QBanner,QInnerLoading,QSpinnerGears,QSeparator,QCardActions,QBtn}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
